'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PricingComparison = renderWithRef('PricingComparison', null, (n, e)=>{
    let { children: s } = n;
    return jsx(RenderComp, {
        root: "span",
        forwardedRef: e,
        classNames: new Set([
            'swan-pricing-comparison'
        ]),
        props: n,
        children: s
    });
});

export { PricingComparison };
